import { parseData, post } from './common';
const getCredentialsByCompany = () => {
    return post('/InternalAPI/SFTPAPI.asmx/GetCredentialsByCompany').then(parseData);
};
const createExistingCredentials = (ID, Username) => {
    return post('/InternalAPI/SFTPAPI.asmx/CreateExistingCredentials', {
        ID,
        Username
    }).then(parseData);
};
const removeExistingCredentials = (Username, Hostname) => {
    return post('/InternalAPI/SFTPAPI.asmx/RemoveExistingCredentials', {
        Username,
        Hostname
    }).then(parseData);
};
const updateCredentials = (Credentials) => {
    return post('/InternalAPI/SFTPAPI.asmx/UpdateCredentials', {
        SFTPCredentials: Credentials
    }).then(parseData);
};
const createNewPassword = () => {
    return post('/InternalAPI/SFTPAPI.asmx/GenerateNewPassword').then(parseData);
};
const createNewFluffyname = () => {
    return post('/InternalAPI/SFTPAPI.asmx/GenerateClientFluffyName').then(parseData);
};
export { createExistingCredentials, removeExistingCredentials, getCredentialsByCompany, updateCredentials, createNewPassword, createNewFluffyname };
